module.exports = __webpack_public_path__ + "img/block1.47e44a1d.svg";